export default __webpack_public_path__ + "static/media/piggy_bank.7b4fb715.svg";